module.exports = __webpack_public_path__ + "media/sf-mouth-bouhbouhbouh_04.9885f6ab.mp3";